var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject1Coordinate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_25443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39209 6.39211V8.82214C7.06812 8.86107 7.72986 9.00021 8.35709 9.23199C8.61896 8.38135 8.77273 7.41169 8.80416 6.39209H6.39209V6.39211Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1958 6.39209C3.22723 7.41169 3.381 8.38135 3.64287 9.23199C4.27013 9.00019 4.93184 8.86107 5.60787 8.82214V6.39209H3.1958Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64287 2.76807C3.381 3.61871 3.22723 4.58836 3.1958 5.60796H5.60787V3.17792C4.93186 3.13899 4.27013 2.99986 3.64287 2.76807Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39209 9.60791V11.9488C6.9477 11.7673 7.48664 11.2083 7.91377 10.354C7.9756 10.2304 8.03429 10.102 8.09011 9.96972C7.54779 9.76876 6.9762 9.64595 6.39209 9.60791Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90991 9.96972C3.96574 10.1019 4.02443 10.2303 4.08626 10.354C4.5134 11.2083 5.05233 11.7673 5.60794 11.9488V9.60791C5.02383 9.64595 4.45223 9.76876 3.90991 9.96972Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2199 1.7207C9.86323 2.00341 9.48122 2.24805 9.07983 2.45209C9.38058 3.39817 9.5558 4.47754 9.58883 5.60779H12C11.9019 4.09105 11.2391 2.72582 10.2199 1.7207Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01343 0.333984C8.23048 0.608133 8.43242 0.92925 8.61547 1.29541C8.68238 1.42922 8.74587 1.56785 8.80634 1.71045C9.0878 1.56187 9.35811 1.39059 9.61451 1.19759C9.13201 0.833531 8.59306 0.540586 8.01343 0.333984Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08626 1.64607C4.02443 1.76973 3.96574 1.89814 3.90991 2.0304C4.45223 2.23138 5.02383 2.35417 5.60794 2.39221V0.0512695C5.05233 0.232746 4.51338 0.791801 4.08626 1.64607Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3855 1.19759C2.6419 1.39057 2.91219 1.56187 3.19367 1.71042C3.25412 1.56785 3.31765 1.42922 3.38454 1.29541C3.56764 0.929273 3.76955 0.608133 3.98658 0.333984C3.40697 0.540563 2.86805 0.833484 2.3855 1.19759Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80634 10.2896C8.7459 10.4321 8.68236 10.5708 8.61547 10.7046C8.43237 11.0707 8.23046 11.3918 8.01343 11.666C8.59304 11.4594 9.13198 11.1665 9.61451 10.8024C9.35808 10.6094 9.0878 10.4381 8.80634 10.2896Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38454 10.7046C3.31765 10.5708 3.25414 10.4321 3.19367 10.2896C2.91221 10.4381 2.6419 10.6094 2.3855 10.8024C2.86803 11.1664 3.40695 11.4594 3.98658 11.666C3.76953 11.3918 3.56759 11.0707 3.38454 10.7046Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41116 6.39209H0C0.0981563 7.9088 0.760922 9.27399 1.78008 10.2792C2.13675 9.99645 2.51878 9.75183 2.92017 9.54776C2.6194 8.60173 2.44418 7.52232 2.41116 6.39209Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58883 6.39209C9.5558 7.52232 9.38056 8.60171 9.07983 9.54779C9.48122 9.75181 9.86323 9.99647 10.2199 10.2792C11.239 9.27404 11.9018 7.90882 12 6.39211H9.58883V6.39209Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35709 2.76807C7.72983 2.99986 7.06812 3.13899 6.39209 3.17792V5.60794H8.80416C8.77273 4.58836 8.61893 3.61871 8.35709 2.76807Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91377 1.64607C7.48662 0.791801 6.9477 0.232746 6.39209 0.0512695V2.39221C6.9762 2.35417 7.54779 2.23138 8.09011 2.0304C8.03431 1.89817 7.97562 1.76975 7.91377 1.64607Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78008 1.7207C0.760922 2.72582 0.0981563 4.09105 0 5.60777H2.41113C2.44416 4.47754 2.6194 3.39813 2.92013 2.45207C2.51876 2.24805 2.13675 2.00338 1.78008 1.7207Z",
    fill: "#CDCED7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_25443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject1Coordinate);
export default __webpack_public_path__ + "static/media/project1_coordinate.360db3ea6518268366c6d6dded06a1ae.svg";
export { ForwardRef as ReactComponent };